<template lang="pug">
.change-labels-modal
  b-modal(v-model="_value" :size="size" @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    div(slot="modal-title")
      span {{ title }}
    
    .register-body.d-flex.flex-column.mb-2
      span(style="font-weight: bold;") ラベル情報を入力してください。
      .mb-2
      .labels
        .label.mb-3.ml-3(v-for="label in labels")
          b-form-checkbox(v-if="label.use" :id="'change-label-' + label.id" v-model="label.checked" :name="'change-label-' + label.id" :value="true" :unchecked-value="false")
            span.waiter-label.mr-2(:style="{ 'color': label.color, 'background-color': label.bgColor }") {{ label.name }}
            span {{ label.description }}

    template(#modal-footer="{ ok, cancel }")
      b-button.btn.modal-ok-btn(@click="ok") {{ okButtonLabel }}
      b-button.btn.modal-cancel-btn(@click="cancel") {{ cancelButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { WaiterLabelsGetModel } from "@/commons/services/WaiterLabels";

/**
 * ### OK/キャンセルモーダル
 */
@Component({})
export default class ChangeLabelsModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** タイトル */
  @Prop({ required: true })
  title!: string;
  /** モーダルサイズ */
  @Prop({ default: () => "lg" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "更新" })
  okButtonLabel!: string;
  /** キャンセルボタンラベル */
  @Prop({ default: () => "キャンセル" })
  cancelButtonLabel!: string;

  /** ラベル選択肢 */
  @Prop()
  labels!: Array<WaiterLabel>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _labels(): Array<WaiterLabel> {
    return this.labels;
  }

  set _labels(newValue: Array<WaiterLabel>) {
    this.$emit("update:labels", newValue);
    return;
  }

  public async ok(): Promise<void> {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
export interface WaiterLabel extends WaiterLabelsGetModel {
  /** チェック */
  checked: boolean;
}
</script>

<style lang="scss" scoped>
.waiter-label {
  margin: 2px 0;
  font-size: 12px;
  padding: 4px;
  border-radius: 0.25rem;
}
</style>
